import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";

import { EVOTRUX_BORDER_GREY } from "constants/index";
import { ISOStringToLocalReadableTimestamp } from "utils";

import { TfcReadOnlyTable } from "./TfcReadOnlyTable";

import type { TfcHistoryEntry } from "utils";

interface TfcHistoryDetailDialogProps {
  entry: TfcHistoryEntry;
  currency: string;
  bookedPriceCents: number;
  onClose: () => void;
}

export function TfcHistoryDetailDialog(props: TfcHistoryDetailDialogProps) {
  const { entry, currency, bookedPriceCents, onClose } = props;
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 500, fontSize: "20px", pb: 1 }}>
        {entry.actionLabel}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: "14px", color: "#6B7280", mb: 2 }}>
          Action performed by{" "}
          <strong
            style={{ color: "#000000" }}
          >{`${entry.byName} (${entry.byCompany})`}</strong>
          {" on "}
          <strong style={{ color: "#000000" }}>
            {ISOStringToLocalReadableTimestamp(entry.at)}
          </strong>
        </Typography>
        <TfcReadOnlyTable
          lineItems={entry.lineItems}
          totalCents={entry.totalCents}
          currency={currency}
          bookedPriceCents={bookedPriceCents}
        />
        {entry.notes.length > 0 && (
          <Box
            sx={{
              mt: 2,
              p: 2,
              backgroundColor: "#FAFAFA",
              border: `1px solid ${EVOTRUX_BORDER_GREY}`,
              borderRadius: "4px",
            }}
          >
            {entry.notes.map((note, idx) => (
              <Box key={note.from + idx.toString()}>
                {idx > 0 && (
                  <Divider sx={{ borderColor: "#EEEEEE", my: 1.5 }} />
                )}
                <Typography sx={{ fontWeight: 600, fontSize: "12px", mb: 0.5 }}>
                  {`Note from ${note.from}:`}
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                  {note.message}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button onClick={onClose} sx={{ color: "#6B7280" }}>
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
}
